<app-modal [isVisible]="isVisible">
    <div class="reviewed-modal-container">
        <h3>{{ "DASHBOARD.ORDER.REVIEWED_MODAL.TITLE" | translate | uppercase }}</h3>
        <i class="fas fa-thumbs-up"></i>
        <p class="close fedrigoni-link" (click)="closeModal()">
            {{ "DASHBOARD.ORDER.CLOSE" | translate | uppercase }}</p>
    </div>
</app-modal>